import axios from 'axios'

const api = axios.create({ baseURL: '/api/v1/portal', timeout: 15000 })

export const getSiteConfig = (lang) => api.get(`/config?lang=${lang}`)
export const getBanners = (lang, position = 'home') => api.get(`/banners?lang=${lang}&position=${position}`)
export const getProducts = (params) => api.get('/products', { params })
export const getProduct = (id, lang) => api.get(`/products/${id}?lang=${lang}`)
export const getSolutions = (params) => api.get('/solutions', { params })
export const getSolution = (id, lang) => api.get(`/solutions/${id}?lang=${lang}`)
export const getSolutionCategories = (lang) => api.get(`/solution-categories?lang=${lang}`)
export const getCases = (params) => api.get('/cases', { params })
export const getCase = (id, lang) => api.get(`/cases/${id}?lang=${lang}`)
export const getArticles = (params) => api.get('/articles', { params })
export const getArticle = (id, lang) => api.get(`/articles/${id}?lang=${lang}`)
export const getCategories = (lang) => api.get(`/categories?lang=${lang}`)
export const getDictItems = (dictType) => api.get(`/dict/${dictType}`)
export const getCompany = (lang) => api.get(`/company?lang=${lang}`)
export const getCustomers = (lang) => api.get(`/customers?lang=${lang}`)
export const getDownloads = (params) => api.get('/downloads', { params })
export const recordDownload = (id) => api.post(`/downloads/${id}/download`)
export const getCertificates = (lang) => api.get(`/certificates?lang=${lang}`)
export const getMapMarkers = (lang) => api.get(`/map-markers?lang=${lang}`)
export const getContacts = (lang) => api.get(`/contacts?lang=${lang}`)
export const submitMessage = (data) => api.post('/message', data)
